export default "__VITE_ASSET__S0tNyyID__"